export default {
    SET_FEATURES(state, features) {
        state.features = features;
    },
    SET_ASSEMBLED(state, assembled){
        state.assembled = assembled
    }
}
